import React, {useContext, useEffect, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {
    Elink,
    FetchAllEstimateRoomsUrl,
    DeleteEstimateRoomUrl, RenameRoomUrl, LastPageVisited,ClientPortalUrl
} from "../CommonComponents/Routes";
import './thirdPage.css';
import UpdateFloorModal from "./UpdateFloorModal";
import {Modal} from "react-bootstrap";
import {AnimationPrevious} from "./AnimationPrevious";
import {Animation} from "./Animation";
import MobileLinkLoader from "./MobileLinkLoader";
import {GetTextColor} from "./GetTextColor";

export default () => { // This component render all rooms
    const [BodyState, setBodyState] = useState("MINI-LOADING")
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    let JobIsOpen = RecordController.IsCustomerEditEstAftrBook
    const [IsDelete, SetIsDelete] = useState(false);
    const [IsRename, SetIsRename] = useState(false);
    const [GoToCp, SetGoToCp] = useState(true);
    const [RoomName, SetRoomName] = useState('');
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    useEffect(async () => {
        if (RecordController.Click) {
            Animation("myroom-page",RecordController.Click); // add animation while picking the call
        }
        await axios({// fetch estimate rooms
            method: 'post',
            url: FetchAllEstimateRoomsUrl,
            params: {estimate_key: Elink}
        }).then(async (response) =>{
            await RecordController.SetEstimateRooms(response.data.EstimateRooms);
            await RecordController.SetCompanyFloors(response.data.CompanyFloors);
            await setBodyState("Get Details");
        });
        await axios({ // update customer's last visit
            method: 'post',
            url: LastPageVisited,
            params: {estimate_key: Elink, last_visited_page: 'SHOW_MOBILE_LINK_MY_ROOMS'}
        })
    }, [])

    const getRoomDetails = (props)=>{ // get room details of a room
        if (props.Room) {
            RecordController.setRoom(props.Room);
            AnimationPrevious ( "next-go",  "myroom-page",  "MOBILE_ROOM_DETAIL", PageView);
            RecordController.SetClick('next');
        }
    }

    const ShowRoom = (props) => { // show room and floor detail
        let Room = props.Room
        return (
            <>
                <div className="col-6 col-md-6 col-lg-3">
                    <div className="card-item">
                        <div className="card-body">
                            <div className="dropdown" style={{float: "right"}}>
                                <div className="dots" data-toggle="dropdown">
                                    <img src={process.env.PUBLIC_URL + "/Images/dots.png"} style={{cursor: "pointer"}} />
                                </div>
                                <ul className="dd-menu-dots dropdown-menu dropdown-menu-right">
                                    <li className="dropdown-item" onClick={()=> RenameRoom({Room})}>Rename</li>
                                    <li className="delete-btn dropdown-item" onClick={()=>DeleteRoom({Room})}>Delete</li>
                                </ul>
                            </div>
                            <br/>
                            <h4 className="card-title" style={{cursor: "pointer"}} onClick={()=> getRoomDetails({Room})}>{Room.Name}</h4><br/>
                            <h6 className="btn btn-sm-2 btn-light" onClick={()=> getCompanyFloors({Room})}>
                                { RecordController.UpdateFloor && RecordController.Room.Id === Room.Id ? "Updating.." : "Floor: "+Room.Floor }
                            </h6>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const DeleteRoom = (props) =>{// this component is used to show delete room modal
        SetIsDelete(true);
        RecordController.setRoom(props.Room);
    }

    const RenameRoom = (props) =>{ // this component is used to rename room modal
        SetIsRename(true);
        RecordController.setRoom(props.Room);
        SetRoomName(props.Room.Name);
    }

    const ConfirmDeleteRoom = () =>{
        SetIsDelete(false);
        axios({
            method: 'post',
            url: DeleteEstimateRoomUrl,
            params: {estimate_key: Elink, room_est_id: RecordController.Room.Id}
        }).then((response) =>{
            RecordController.SetEstimateRooms(response.data.EstimateRooms);
        });
    }

    const ConfirmRenameRoom = () =>{
        SetIsRename(false);
        axios({
            method: 'post',
            url: RenameRoomUrl,
            params: {estimate_key: Elink, room_est_id: RecordController.Room.Id, name: RoomName}
        }).then((response) =>{
            RecordController.SetEstimateRooms(response.data.EstimateRooms);
        });
    }

    const getCompanyFloors = (props) =>{ // this component is used to open floors modal
        RecordController.setRoom(props.Room);
        RecordController.setCustomItemModal(true);
    }

    const handleModal = () =>{
        SetIsRename(false);
        SetIsDelete(false)
        RecordController.setCustomItemModal(false);
    }

    const AddNewRoom = () =>{ // this component is used to open new page for adding new room
        RecordController.SetClick('next');
        AnimationPrevious ( "next-go",  "myroom-page",  "ADD_NEWROOM", PageView);
    }

    const ReviewAndSubmit =() =>{ // this component is used to open review and submit page
        RecordController.SetClick('next');
        AnimationPrevious ( "next-go",  "myroom-page",  "REVIEW_AND_SUBMIT", PageView);
    }
    const openClientPortal = () => { // this component is used to open client portal in new tab
        if(GoToCp) {
            SetGoToCp(false);
            axios({
                method: 'post',
                url: ClientPortalUrl,
                params: {estimate_key: Elink}
            }).then(async (response) => {
                let url = response.data.url
                await window.open(url, "_blank");
                await SetGoToCp(true);
            })
        }
    }

    const showAddedRooms = () => { // this component is used to show added rooms information
        return(
            <>
                <Modal className="alert-modal" show={!JobIsOpen || RecordController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                                "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container rooms-container"><br/>
                    <div className="row my-home-heading" style={{marginTop: "3%"}}>
                        <div className="col-md-2 col-lg-3 col-xl-3">
                        </div>
                        <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                            <div className="header-tx text-center">
                                <h3 id="my-home-h" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>My Home</h3>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-3 col-xl-3">
                        </div>
                    </div>
                    <div className={"row align-items-center"}>
                    <div className={"col-lg-12 col-md-12 col-sm-12 my-rooms-page"} >
                        {
                            // this button will appears when customer open link from mobile inventory link not using sms or email
                            new URLSearchParams(window.location.search).get('goto') === 'mobile_inventory' ? <></> :
                                <button type={"submit"} className={" btn-sm go-to-portal"}
                                        onClick={() => openClientPortal(GoToCp)} disabled={!GoToCp}
                                        style={{backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>
                                    <b>Go To Customer Portal</b>
                                </button>
                        }
                        {
                            // add loader because sometimes it takes time to fetch the details
                            BodyState === "MINI-LOADING" ? <MobileLinkLoader Height={"45vh"}/> :
                            <>
                                <div className="text-center" style={{marginTop: '0.5rem'}}>
                                    <div className="row d-flex text-center" style={{height: "53vh", overflow: "scroll"}}>
                                        {!GoToCp ?
                                            <div className={"col-lg-10 col-md-10 col-sm-8 col-6"} style={{position: "absolute", zIndex: 1}}>
                                                <img src={process.env.PUBLIC_URL + `Images/Loader18.gif`}  alt="LOADING.."
                                                     style={{position: "absolute", zIndex: 1, background: "transparent", width: "250px", height: "335px"}}/>
                                            </div>
                                            : <></>}
                                        {Object.keys(RecordController.EstimateRooms).length > 0 ?
                                            Object.entries(RecordController.EstimateRooms).map(([id, Room]) => {
                                                return (<ShowRoom key={id} Room={Room}/>)
                                            })
                                            :
                                            <></>
                                        }
                                        <div className="col-6 col-md-6 col-lg-3">
                                            <div className="card-item-add">
                                                <div className="card-body-add" style={{cursor: "pointer"}}
                                                     onClick={() => AddNewRoom()}>
                                                    <h5 className="card-title">Add Room +</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    <UpdateFloorModal Floor={RecordController.Room} For={'MyHome'}/>
                                </div>
                            {
                                // delete modal
                                IsDelete ?
                                    <Modal id="mobile-link-modal" show={IsDelete} onHide={() => handleModal()}>
                                        <Modal.Header><h4 className="custom-item-heading"><b>Delete Room?</b></h4></Modal.Header>
                                            <Modal.Body>
                                                <p className="text-center mb-4">Are you sure want to remove this room?</p>
                                                <button type="button" className="btn btn-delete mb-4" data-bs-dismiss="modal" onClick={()=>ConfirmDeleteRoom()}>Yes, delete this
                                                room
                                                </button>
                                                <button type="button" className="btn btn-no mb-4" onClick={()=> handleModal()}>No, Thanks</button>
                                            </Modal.Body>
                                    </Modal> : <></>
                            }
                            {
                                // rename modal
                                IsRename ?
                                    <Modal id="mobile-link-modal" show={IsRename} onHide={() => handleModal()}>
                                        <Modal.Header><h4 className="custom-item-heading"><b>Rename Room</b></h4></Modal.Header>
                                        <Modal.Body>
                                            <div className="mb-3"><input type="text" className="form-control" id="#" onChange={(e)=>SetRoomName(e.target.value)} style={{width: "100%"}} value={RoomName}/></div>
                                            <button type="button" className="btn btn-rename mb-4" data-bs-dismiss="modal" onClick={()=>ConfirmRenameRoom()}
                                                    style={{backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>Confirm</button>
                                            <button type="button" className="btn btn-cancel mb-4" onClick={()=> handleModal()}
                                                    style={{color: CustomerInvReq.ButtonColor}}>Cancel</button>
                                        </Modal.Body>
                                    </Modal> : <></>
                            }
                            <div className="btn-review">
                                <button className="btn-st-review" type="submit" onClick={()=>ReviewAndSubmit()}
                                style={{backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}><b>REVIEW AND SUBMIT</b></button>
                            </div>
                            </>
                        }
                    </div>
                    </div>
                </div>
            </>
        )
    }

    return(
    <>
        <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>
            <div className={"myroom-page"} style={{width: "100vw", position: "relative"}}>
                {showAddedRooms()}
            </div>
        </section>
        <section className="mobile-section-4 mobile-vw" style={{background: CustomerInvReq.BackgroundColor}}>
            <svg id="curve" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1416.99 174.01">
                <path className="curve-path" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z"
                      transform="translate(0-135.53)" style={{position:"relative"}} fill="#f2f5f8"/>
                <path className="curve-path"
                      d="M77.8,230.3S283.66,353,880.94,275.58s937.93,190.57,920,10.34V309.54H0V280.8Z"
                      transform="translate(0-135.53)" style={{position:"relative"}} fill="white"/>
            </svg>
            <div className={"myroom-page"} style={{width: "100vw", position: "relative"}}>
                {showAddedRooms()}
            </div>
        </section>
    </>)
}

